import { render, staticRenderFns } from "./TinyInfoToPayVat.vue?vue&type=template&id=4ace4b75"
import script from "./TinyInfoToPayVat.vue?vue&type=script&lang=ts"
export * from "./TinyInfoToPayVat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ace4b75')) {
      api.createRecord('4ace4b75', component.options)
    } else {
      api.reload('4ace4b75', component.options)
    }
    module.hot.accept("./TinyInfoToPayVat.vue?vue&type=template&id=4ace4b75", function () {
      api.rerender('4ace4b75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfoToPayVat.vue"
export default component.exports